import { useSelector } from 'react-redux';
import DashboardCard from '/@/components/bayer/dashboard-card';
import useUnitProvider from '/@/core/context/unit';
import { useFieldsDashboard } from '/@/hooks/dashboards';
import { convertAreaFromM2 } from '/@/hooks/geometry/area';
import { _ } from '/@/locale';
import { getSessionCountry } from '/@/store/session/selectors';
import { getNodeScopeFilters } from '/@/utils/node-scope';

const FieldsDashboardCard = () => {
    const country = useSelector(getSessionCountry);
    const fieldsDashboardQuery = useFieldsDashboard({
        country: country.code,
        ...getNodeScopeFilters('rvs'),
    });
    const units = useUnitProvider();

    return (
        <DashboardCard
            title={_('Lotes')}
            subtitle={`${_('Superficie total: {{value}}', {
                value: convertAreaFromM2(fieldsDashboardQuery.data?.totalArea || 0, units).toString(),
            })}`}
            isLoading={fieldsDashboardQuery.isLoading}
            number={fieldsDashboardQuery.data?.count}
        />
    );
};

export default FieldsDashboardCard;
